import { useSyncExternalStore } from 'react'

/**
 * The phone layout and the desktop layout are genuinely different shapes, not
 * one layout stretched. This is the line between them.
 */
export const DESKTOP_QUERY = '(min-width: 900px)'

function subscribe(query: string) {
  return (onChange: () => void) => {
    const media = window.matchMedia(query)
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    subscribe(query),
    () => window.matchMedia(query).matches,
    () => false,
  )
}

export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_QUERY)
}
